import { EventEmitter } from "pixi.js";

export enum EnumEventBus {
  setCalcLine = "SET_CALC_LINE",
  showCalcLine = "SHOW_CALCULATION_LINE",
  setCircumPoint = "SET_CIRCUMFERENCE_POINT",
  setCentralAngle = "SET_CENTRAL_ANGLE",
  setRotateCircle = "SET_ROTATE_CIRCLE",
  segmentMode = "SEGMENT_MODE",
}

export const eventBus = new EventEmitter();